import { AxiosGETRequest, AxiosMutationRequest, RequestMethod } from '@myme/utils';

export const createBlobAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/blobs-library'
};

export const addMediaFileAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/media-library'
};

export const deleteBlobAPI: AxiosMutationRequest = {
  method: RequestMethod.DELETE,
  path: '/blobs-library/:blobId'
};

export const deleteMediaFileAPI: AxiosMutationRequest = {
  method: RequestMethod.DELETE,
  path: '/media-library/:fileId'
};

export const deleteQuizQuestionAPI: AxiosMutationRequest = {
  method: RequestMethod.DELETE,
  path: '/blobs-library/:blobId/questions/:questionId'
};

export const deleteQuizAnswerAPI: AxiosMutationRequest = {
  method: RequestMethod.DELETE,
  path: '/blobs-library/:blobId/answers/:answerId'
};

export const checkConsequencesBeforeMediaDeleteAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['checkConsequencesBeforeMediaDeleteAPI'],
  path: '/media-library/before-delete/:fileId'
};

export const checkConsequencesBeforeBlobDeleteAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['checkConsequencesBeforeBlobDeleteAPI'],
  path: '/blobs-library/before-delete/:blobId'
};

export const editBlobAPI: AxiosMutationRequest = {
  method: RequestMethod.PATCH,
  path: '/blobs-library/:blobId'
};

export const getBlobsAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  path: '/blobs-library',
  cacheKeys: ['getBlobsAPI']
};

export const getSingleBlobAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['getSingleBlobAPI'],
  path: '/blobs-library/:blobId'
};

export const getMediaFilesAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  path: '/media-library',
  cacheKeys: ['getMediaFilesAPI']
};

export const updateBlobProgressAPI: AxiosMutationRequest = {
  method: RequestMethod.PUT,
  path: '/progress/:mymeId/:moduleId/:blobId'
};
